<li class="profile-memeber-container margin-bottom-5">
  <a class="profile-view" (click)="route(userinfo,false)">
    <!-- Job rows (Jobs From Connections / Marketplace Job / Featured Jobs):
         job-title initials tile (job-profile-slider header look), shown
         instead of the poster's photo/initials -->
    <div *ngIf="page === 'JOBS' || page === 'SUGGJOBS'" class="job-initials-tile" [title]="data?.jobTitle || ''" (click)="route(userinfo, true)">{{ jobInitials }}</div>

    <!-- Candidate rows (Candidates From Connections / Marketplace Candidates /
         Featured Candidates): the CANDIDATE's own uploaded photo when present,
         else a candidate-name initials tile (candidate-profile-slider header
         look). Never the owner's photo — wrong person next to the name. -->
    <div *ngIf="(page === 'CANDIDATES_MIGHT' || page === 'CANDIDATES') && img && !imgFailed"
      class="candidate-photo-tile"
      [title]="(((data?.firstName || '') | titlecase) + ' ' + ((data?.lastName || '') | titlecase))"
      (click)="route(userinfo, true)">
      <img [src]="img" alt="" (error)="imgFailed = true" />
    </div>
    <div *ngIf="(page === 'CANDIDATES_MIGHT' || page === 'CANDIDATES') && (!img || imgFailed)" class="job-initials-tile"
      [title]="(((data?.firstName || '') | titlecase) + ' ' + ((data?.lastName || '') | titlecase))"
      (click)="route(userinfo, true)">{{ getInitialstwo(data?.firstName, data?.lastName) }}</div>

    <!-- Show image for users with photo OR businesses/communities with logo -->
    <div *ngIf="page !== 'JOBS' && page !== 'SUGGJOBS' && page !== 'CANDIDATES_MIGHT' && page !== 'CANDIDATES' && ((userinfo?.photo !== null && userinfo?.photo !== undefined) || (type === 'BUSINESS' && data?.businessLogo) || (type === 'COMMUNITY' && data?.communityLogo))">
      <img [title]="page === 'SUGGJOBS' ? (data?.jobTitle || '') : page === 'CANDIDATES_MIGHT' ? (((data?.firstName || '') | titlecase) + ' ' + ((data?.lastName || '') | titlecase)) : (userinfo?.firstName || '') + ' ' + (userinfo?.lastName || '')"
        [src]="img"  class="profile-photo"
        (click)="route(userinfo, true)"
        [ngClass]="{ business: type === 'BUSINESS' || type === 'COMMUNTIY' || type === 'POST' || type === 'HASHTAG' || type === 'JOBS' || type === 'CANDIDATES' || type==='SUGGJOBS' || type==='CANDIDATES_MIGHT'}" />
    </div>

    <!-- Show default company image for BUSINESS without logo -->
    <div *ngIf="type === 'BUSINESS' && !data?.businessLogo" (click)="route(userinfo, true)">
      <img title="{{data?.businessName}}" src="assets/images/gallery/company.png" class="profile-photo business" />
    </div>

    <!-- Show initials for other types without photo -->
    <div *ngIf="page !== 'JOBS' && page !== 'SUGGJOBS' && page !== 'CANDIDATES_MIGHT' && page !== 'CANDIDATES' && (userinfo?.photo === null || userinfo?.photo === undefined) && type !== 'COMMUNTIY' && type !== 'BUSINESS' && type !== 'COMMUNITY'" (click)="route(userinfo, true)"
      [ngClass]="{ business: type === 'POST' || type === 'HASHTAG' || type === 'JOBS' || type === 'CANDIDATES' || type==='SUGGJOBS' || type==='CANDIDATES_MIGHT'}">
      <!-- Show circles with initials -->
      <div [title]="page === 'SUGGJOBS' ? (data?.jobTitle || '') : page === 'CANDIDATES_MIGHT' ? (((data?.firstName || '') | titlecase) + ' ' + ((data?.lastName || '') | titlecase)) : (userinfo?.firstName || '') + ' ' + (userinfo?.lastName || '')"
        class="circles" [style.background-color]="getColortwo(userinfo?.firstName, userinfo?.lastName)">
        <div class="circle-text" [style.color]="getTextColor(userinfo?.firstName, userinfo?.lastName)">{{ getInitialstwo(userinfo?.firstName, userinfo?.lastName) }}</div>
      </div>
    </div>

    <div *ngIf="(userinfo?.photo === null || userinfo?.photo === undefined) && (type === 'COMMUNTIY' || (type === 'COMMUNITY' && !data?.communityLogo))" (click)="route(userinfo, true)">
      <div  class="svg-background-community">
        <ng-icon name="tablerUsersGroup" class="svg-position"></ng-icon>
      </div>
    </div>

    <div class="profile-detail">
      <h6 class="profile-section-detail fw-bold">
        <span class="profile-name card-title-font"
          [title]="page === 'JOBS' || page === 'SUGGJOBS' ? (data?.jobTitle || '')
            : page === 'CANDIDATES_MIGHT' || page === 'CANDIDATES' ? (((data?.firstName || '') | titlecase) + ' ' + ((data?.lastName || '') | titlecase))
            : (userinfo?.firstName || '') + ' ' + (userinfo?.lastName || '')">
          <ng-content select="[headline1]"></ng-content>
        </span>
      </h6>
      <div class="profile-headline">
        <span class="profile-inline card-subtitle-font" >
          <ng-content select="[headline2]"></ng-content>
        </span>
      </div>
    </div>
  </a>

  <div class="profile-btn">
    <ng-content select="[btn]" (click)="datapass(userinfo.userId)"></ng-content>
  </div>
</li>
